<div class="col px-lg-5 px-2">
	<app-nav-routes class="row pb-5"> </app-nav-routes>
	<div class="my-3 text-lg-start">
		<div class="row my-2">
			<app-week-selector
				class="col d-flex flex-row"
				[weekNumber]="weeknumber"
				[yearNumber]="yearnumber"
				[dateRange]="dateRange"
				(dateRangeChange)="updateDates()"
			></app-week-selector>

			<div class="col-lg-3">
				<div class="row">
					<span class="form-control-plaintext w-25 fw-bold theme-main-color"
						>Etat
					</span>
					<select
						[(ngModel)]="this.state"
						class="form-select w-50 border-1"
						id="inputGroupSelect02"
						(ngModelChange)="filterRoutesState()"
					>
						<option [value]="'Tous'">Tous</option>
						<option *ngFor="let state of listState" [value]="state">
							{{ state }}
						</option>
					</select>
				</div>
			</div>

			<div class="col-lg-4">
				<div class="row">
					<span class="col form-control-plaintext fw-bold theme-main-color"
						>Prochaines tournées de</span
					>
					<select
						[(ngModel)]="selectedEmployeeId"
						class="col form-select border-1"
						id="inputGroupSelect02"
						(ngModelChange)="filterRoutes()"
					>
						<option [value]="-1">Tout le monde</option>
						<option *ngFor="let employee of listEmployee" [value]="employee.id">
							{{
								employee.firstName +
									'
                            ' +
									employee.lastName
							}}
						</option>
					</select>
				</div>
			</div>
		</div>

		<div *ngIf="!isMobile" class="row ps-lg-3 mb-2 mt-4">
			<div class="col-3 d-flex justify-content-around">
				<span class="hand-cursor flex-grow-1" (click)="sortChange('date')"
					>Date
					<span
						*ngIf="sortType === 'date' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'date' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>

			<div class="col-3 d-flex justify-content-around">
				<span
					class="hand-cursor flex-grow-1"
					(click)="sortChange('planning.employee.centre')"
					>Centre
					<span
						*ngIf="
							sortType === 'planning.employee.centre' && sortOrder === 'asc'
						"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="
							sortType === 'planning.employee.centre' && sortOrder === 'desc'
						"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>

			<!-- <div class="col-2 d-flex justify-content-around">
				<span
					class="hand-cursor flex-grow-1"
					(click)="sortChange('planning.employee.firstName')"
					>Employé(e)
					<span
						*ngIf="
							sortType === 'planning.employee.firstName' && sortOrder === 'asc'
						"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="
							sortType === 'planning.employee.firstName' && sortOrder === 'desc'
						"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div> -->

			<div class="col-2 d-flex justify-content-around">
				<span
					class="hand-cursor flex-grow-1"
					(click)="sortChange('plannedDistance')"
					>Distance totale
					<span
						*ngIf="sortType === 'plannedDistance' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'plannedDistance' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>

			<div class="col-2 d-flex justify-content-around">
				<span
					class="hand-cursor flex-grow-1"
					(click)="sortChange('plannedDuration')"
					>Durée estimée
					<span
						*ngIf="sortType === 'plannedDuration' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'plannedDuration' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>

			<div class="col-2 d-flex justify-content-around">
				<span *ngIf="!isSESSAD" class="flex-grow-1">Etat</span>
			</div>
			<div class="col-1 d-flex justify-content-around"></div>
		</div>

		<div *ngFor="let routeObject of listRouteObjectWithDetails" class="mt-4">
			<div *ngIf="routeObject.routes.length > 0">
				<div>
					<label class="fs-5 fw-bold" for="intervenant">{{
						routeObject.employee.firstName + ' ' + routeObject.employee.lastName
					}}</label>
				</div>
				<div
					*ngFor="
						let route of routeObject.routes
							| orderBy: sortType:sortOrder:['date']
					"
					class="ps-lg-3 text-lg-start row my-1 py-3 rounded rounded-3 bg-light"
					[ngClass]="{
						'd-none': route?.plannedDistance === 0 || route?.plannedTime === 0
					}"
				>
					<span class="col-lg-3 col-12"
						><span *ngIf="isMobile" class="fw-bold">Date : </span
						>{{ getDateDay(route?.date) }}
						{{ route?.date | date: 'dd/MM/yyyy' }}</span
					>
					<span class="col-lg-3 col-12"
						><span *ngIf="isMobile" class="fw-bold">Centre : </span
						>{{ routeObject?.serviceCenter?.name }}</span
					>

					<!-- <span class="col-lg-2 col-12">
						<span *ngIf="isMobile" class="fw-bold">Employé(e) : </span>
						{{
							routeObject?.employee?.firstName +
								' ' +
								routeObject?.employee?.lastName
						}}</span
					> -->
					<span class="col-lg-2 col-12">
						<span *ngIf="isMobile" class="fw-bold">Distance totale : </span>
						{{ route?.plannedDistance / 1000 | number: '1.1-2' }} km</span
					>
					<span class="col-lg-2 col-12">
						<span *ngIf="isMobile" class="fw-bold">Durée estimée : </span>
						{{ route?.plannedTime | minutesToTime }}
					</span>

					<div class="col-lg-2 col-11">
						<div class="d-flex">
							<span *ngIf="isSESSAD" class="flex-grow-1"></span>
							<span *ngIf="!isSESSAD" class="flex-grow-1">
								<span *ngIf="isMobile" class="fw-bold">Etat : </span>
								<span
									*ngIf="routeState[route.state] === routeState.UNDER_REVIEW"
									class="theme-main-color"
									><i class="bi bi-pencil-fill me-2" aria-hidden="true"></i
									>{{ routeState.UNDER_REVIEW | lowercase }}</span
								>
								<span
									*ngIf="routeState[route.state] === routeState.PENDING"
									class="theme-main-color"
									><i
										class="bi bi-check-circle-fill me-2"
										aria-hidden="true"
									></i
									>{{ routeState.PENDING | lowercase }}</span
								>
								<span
									*ngIf="routeState[route.state] === routeState.IN_PROGRESS"
									class="theme-main-color"
									><i class="bi bi-three-dots me-2" aria-hidden="true"></i
									>{{ routeState.IN_PROGRESS | lowercase }}</span
								>
							</span>
						</div>
					</div>
				</div>
				<div class="row my-1 ps-lg-3 pt-3 pb-1">
					<div class="col-lg-3">
						<span class="fw-bold theme-blue-color">Total :</span>
					</div>
					<div class="col-lg-3"></div>
					<div class="col-lg-2">
						<span class="theme-blue-color fw-bold">
							{{ calculTotal(routeObject.routes, 'dist') | number: '1.1-2' }} km
						</span>
					</div>
					<div class="col-lg-2">
						<span class="theme-blue-color fw-bold">
							{{ calculTotal(routeObject.routes, 'dur') | minutesToTime }}
						</span>
					</div>
					<div class="col-lg-2"></div>
				</div>
				<hr />
			</div>
		</div>
	</div>
</div>
